import React from "react";
import "./FormHeader.css";
import Search from "./Search";

interface FormHeaderProps {
    labelDetails: {
        label: string
        redirectFunction?: () => void
    }[]
    searchFunction?: (value: string) => void;
}

const GenericFormHeader: React.FC<FormHeaderProps> = ({
    labelDetails,
    searchFunction,
}) => {
    return (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className="FormHeader">
                {labelDetails.map((labelDetailsObject, index) =>
                    <>
                        {index != 0 && <>&gt;</>}
                        <span className={index < labelDetails.length-1 ? "FormHeader_parent_text" : "FormHeader_current"} onClick={labelDetailsObject.redirectFunction ? labelDetailsObject.redirectFunction : () => { }}>
                            {labelDetailsObject.label} 
                        </span>
                    </>
                )}
            </div>
            {searchFunction && (
                <div className="searchWidth">
                    <Search searchFunction={searchFunction} />
                </div>
            )}
        </div>
    );
};

export default GenericFormHeader;
